/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(function () {
  $.each(window.DeskPressQuotes || {}, function (sectionId) {
    var section = document.getElementById('shopify-section-' + sectionId);
    if (!section) return;

    var swiperInstance = null;

    function initSwiper() {
      if (window.innerWidth <= 799) {
        if (swiperInstance) return;
        swiperInstance = new Swiper(section.querySelector('.press-quotes__swiper'), {
          slidesPerView: 1,
          spaceBetween: 24,
          pagination: {
            el: section.querySelector('.press-quotes__pagination'),
            clickable: true
          },
          autoplay: {
            delay: 5000,
            disableOnInteraction: false
          }
        });
      } else {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
        }
      }
    }

    initSwiper();
    $(window).on('resize', initSwiper);

    var srElements = section.querySelectorAll('.sr-hidden');
    if (srElements.length) {
      if (window.innerWidth > 799 && typeof ScrollReveal !== 'undefined') {
        srElements.forEach(function (el, i) {
          ScrollReveal().reveal(el, {
            origin: 'bottom',
            distance: '20px',
            duration: 700,
            delay: i * 40,
            easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
            opacity: 0,
            scale: 1,
            once: true
          });
        });
      }
    }
  });
});
